"use strict";

// Module API

function checkMinimum(constraint, value) {
  if (value === null) {
    return true;
  }
  if (value >= constraint) {
    return true;
  }
  return false;
}

module.exports = {
  checkMinimum: checkMinimum
};


//////////////////
// WEBPACK FOOTER
// ./~/tableschema/lib/constraints/minimum.js
// module id = 327
// module chunks = 0